import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { CandidatesFilter } from '@shared/candidate-filters/candidate-filters.model';
import { AssociationLabel } from '@shared/models/association-label.enum';
import { DEFAULT_EXPERIENCES_VALUE } from '@shared/models/experience-filter';

import { jobFilterStateSuccess, jobFilterUpdate } from './matched-candidates-filter.actions';

export const JobFilterKey = 'JobFilter';

export interface JobMatchedCandidatesFilter extends CandidatesFilter {
  jobId: number;
  category?: string;
  passiveModifyDatePeriod: number;
  offset?: number;
  initialStateLoaded?: boolean;
  sortBy?: string;
  sortByLabel?: string;
}

export const DEFAULT_LOCATION_RADIUS_IN_MILES = 50;

export const initialJobMatchedCandidatesFilterState: JobMatchedCandidatesFilter = {
  jobId: null,
  category: AssociationLabel.DIRECT,
  keywords: [],
  locations: null,
  jobTitles: [],
  schools: [],
  fieldOfStudy: [],
  minimumDegree: null,
  experiences: DEFAULT_EXPERIENCES_VALUE,
  locationMilesRadius: DEFAULT_LOCATION_RADIUS_IN_MILES,
  passiveModifyDatePeriod: 0,
  enableYOEFilter: false,
  enableLocationFilter: false,
  internalOnTop: false,
  offset: 0,
  initialStateLoaded: false,
  companies: [],
  skills: [],
};

export interface JobFilterState extends EntityState<JobMatchedCandidatesFilter> {
  selectedId?: string;
}

export const jobFilterEntityAdapter: EntityAdapter<JobMatchedCandidatesFilter> =
  createEntityAdapter<JobMatchedCandidatesFilter>({
    selectId: (filter: JobMatchedCandidatesFilter) => filter.jobId,
    sortComparer: false,
  });

export const initialState: JobFilterState = jobFilterEntityAdapter.getInitialState({
  selectedId: null,
});

const inlineJobFilterReducer = createReducer(
  initialState,
  on(jobFilterUpdate, (state, { filter }) =>
    jobFilterEntityAdapter.upsertOne(filter, {
      ...state,
    }),
  ),
  on(jobFilterStateSuccess, (state, { filter }) =>
    jobFilterEntityAdapter.addOne(filter, {
      ...state,
    }),
  ),
);

export function jobFilterReducer(state: JobFilterState, action: Action) {
  return inlineJobFilterReducer(state, action);
}
